import { InputAdornment } from '@mui/material'
import { TFunction } from 'i18next'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormTextField } from './FormCore'

export type CoordinateDirection = 'latitude' | 'longitude'

export function getCoordinateDirectionMarker(value: unknown, direction: CoordinateDirection, t: TFunction): string {
  if (value === '' || value === null || value === undefined) return ''
  const numeric = typeof value === 'number' ? value : parseFloat(String(value))
  if (isNaN(numeric)) return ''

  if (direction === 'latitude') {
    return numeric < 0 ? t('direction_south', { ns: 'common' }) : t('direction_north', { ns: 'common' })
  }
  return numeric < 0 ? t('direction_west', { ns: 'common' }) : t('direction_east', { ns: 'common' })
}

type CoordinateFormFieldProps = React.ComponentProps<typeof FormTextField> & {
  name: string
  direction: CoordinateDirection
}

export const CoordinateFormField: React.FC<CoordinateFormFieldProps> = ({ direction, InputProps, ...rest }) => {
  const { t } = useTranslation(['common'])
  const value = useWatch({ name: rest.name })
  const marker = getCoordinateDirectionMarker(value, direction, t)

  return (
    <FormTextField
      {...rest}
      InputProps={{
        ...InputProps,
        endAdornment: marker ? <InputAdornment position="end">{marker}</InputAdornment> : InputProps?.endAdornment,
      }}
    />
  )
}
